import { FormParagraphFormGroupField } from '@frontend/components/fields/FormParagraphField';
import { useServiceOrganizationSettingContext } from '@frontend/utils/hooks/useServiceOrganizationsSettingsContext';

export function ServiceOrganizationSettingZorgmailRead() {
    const { serviceOrganizationSetting } = useServiceOrganizationSettingContext();

    return (
        <FormParagraphFormGroupField
            label="serviceOrganizationSetting.zorgMailNumber"
            value={serviceOrganizationSetting.zorgmailNummer}
        />
    );
}
